import { Component, effect, inject, input, viewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatTableDataSource } from '@angular/material/table';
import { RouterLink } from '@angular/router';
import { ButtonComponent } from '@banyan/commons/components/button/button.component';
import { AccountService } from '@banyan/features/account/services/account.service';
import { CartEmptyComponent } from '@banyan/features/cart/components/cart-empty/cart-empty.component';
import { CartTableV2Component } from '@banyan/features/cart/components/cart-table-v2/cart-table-v2.component';
import { CartV2Service } from '@banyan/features/cart/services/cart-v2.service';
import { TranslatePipe } from '@ngx-translate/core';


@Component({
  selector: 'app-popin',
  templateUrl: './popin-menu.component.html',
  styleUrls: ['./popin-menu.component.scss'],
  standalone: true,
  imports: [
    MatIconModule,
    RouterLink,
    TranslatePipe,
    ButtonComponent,
    CartEmptyComponent,
    CartTableV2Component,
  ],
})
export class PopinMenuComponent {
  readonly menuTrigger = viewChild(MatMenuTrigger);
  readonly menuId = input<string>('cartV2');
  displayedColumns: string[] = [
    'fragrance',
    'type',
    'qty',
    'unit-price',
    'total',
    'actions',
  ];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  accountService = inject(AccountService);
  cartV2Service = inject(CartV2Service);

  constructor() {
    effect(() => {
      if (this.cartV2Service.cartLoaded()) {
        this.dataSource = new MatTableDataSource<any>(this.cartV2Service.cart()?.lineItems);
      }
    });
  }

  logout() {
    this.accountService.logout();
  }
}
